import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, useColorMode } from 'theme-ui'
import { navigate } from 'gatsby'
import Form from '~/components/Gift/Form'
import GifterCard from '~/components/Gift/GifterCard'
import useRedeemGift from '~/hooks/components/use-redeem-gift'
import useFakeBackNavigationListener from '~/hooks/components/use-fake-back-navigation-listener'
import CustomErrorPage from '~/components/Gift/CustomErrorPage'
import { checkMultiuse } from '~/utils/check-gift-multiuse'

const GIFT_CONFIRMATION_URL = '/gift-from/confirmation?number='

const GiftPage = ({ slug, fakeNavigateTo, gift, states }) => {
  const [, setColorMode] = useColorMode()
  const [formSubmitting, submitGiftForm, submitError] = useRedeemGift(slug)
  const [multiUseError, setMultiUseError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useFakeBackNavigationListener(() => fakeNavigateTo('landing'))

  const redeemGift = async formData => {
    setIsLoading(true)
    setMultiUseError(null)
    const isMultiUse = await checkMultiuse(formData)
    if (isMultiUse) {
      setIsLoading(false)
      setMultiUseError(`Your gift has already been redeemed.`)
    } else {
      setIsLoading(false)
      console.log('Is Gift Redeemed --', isMultiUse)
      const { number: orderNumber, token } = await submitGiftForm(formData)
      if (orderNumber) {
        // gifting app doesnt send the Session id
        // using the token instead to fetch the order data securly
        return navigate(`${GIFT_CONFIRMATION_URL}${orderNumber}&token=${token}`)
      }
    }
  }

  useEffect(() => {
    setColorMode('Gift-Flow-Form')
  }, [])

  const titleStyling = {
    display: 'block',
    color: 'secondary',
    fontFamily: 'heading',
    fontSize: [48, 60],
    lineHeight: 1,
    fontWeight: 700,
    textAlign: 'center',
    maxWidth: [340, 540],
    margin: '0 auto 50px',
    textTransform: 'uppercase',
  }

  return (
    <>
      {submitError ? (
        <CustomErrorPage />
      ) : (
        <Flex sx={{ flexFlow: 'column wrap' }}>
          <Box>
            <GifterCard
              sx={{ margin: '0 25px 0' }}
              avatar={gift?.gift_details?.avatar_url}
              name={gift?.gift_details?.gifters_name}
              message={gift?.gift_details?.message}
            />
            <Form
              formSubmit={redeemGift}
              states={states}
              gifts={gift.products_data}
              formSubmitting={formSubmitting}
              multiUseError={multiUseError}
              isLoading={isLoading}
            />
          </Box>
        </Flex>
      )}
    </>
  )
}

GiftPage.propTypes = {
  slug: PropTypes.string.isRequired,
  fakeNavigateTo: PropTypes.func.isRequired,
  states: PropTypes.array.isRequired,
  gift: PropTypes.object.isRequired,
}

export default GiftPage
